// @core/api/endpoints/document/list_document_templates.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListDocumentTemplatesResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List templates
 * Returns available document templates.
 */
export async function ListDocumentTemplates(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListDocumentTemplatesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/document-templates`;
  const requestOptions = options;
  return client.get<ListDocumentTemplatesResponse>(requestPath, { ...requestOptions, params });
}
